import React, { lazy } from 'react';

/**
 * League charts load on demand: recharts is a separate chunk, fetched only on
 * the team page or the Standings charts view.
 */
const load = () => import('./LeagueCharts');
const lazyChart = (name) => lazy(() => load().then((m) => ({ default: m[name] })));

export const ResultsByNightChart = lazyChart('ResultsByNightChart');
export const CumulativeWinsChart = lazyChart('CumulativeWinsChart');
export const PointsPerGameChart = lazyChart('PointsPerGameChart');
export const HeadToHeadChart = lazyChart('HeadToHeadChart');
export const WinsByTeamChart = lazyChart('WinsByTeamChart');
export const WinRaceChart = lazyChart('WinRaceChart');
export const PointsByTeamChart = lazyChart('PointsByTeamChart');

export const ChartCard = ({ title, children }) => (
  <section className="league-chart" aria-label={title}>
    <h4 className="league-chart__title">{title}</h4>
    {children}
  </section>
);

export const ChartsFallback = () => <p className="league-team-page__note">Loading charts…</p>;
